import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const HelpIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.89 6.427a6.245 6.245 0 1 1 6.898 9.562.75.75 0 0 0 .427 1.438 7.745 7.745 0 1 0-8.554-11.86.75.75 0 0 0 1.23.86Zm-.883 4.09a1.751 1.751 0 0 0-1.76 1.737A1.757 1.757 0 0 0 8 14.02a1.751 1.751 0 0 0 .008-3.502Zm-2.51 1.733-.75-.006a3.251 3.251 0 0 1 6.502.033A3.251 3.251 0 0 1 8 15.52h-.003a3.257 3.257 0 0 1-3.249-3.274l.75.004Zm0 4.252h5.004a3.258 3.258 0 0 1 3.25 3.249v.63a1.377 1.377 0 0 1-1.374 1.372H3.62a1.377 1.377 0 0 1-1.373-1.372l.75-.003h-.75v-.627a3.258 3.258 0 0 1 3.249-3.249h.002Zm-1.75 3.752h8.503v-.5a1.758 1.758 0 0 0-1.752-1.752h-5a1.758 1.758 0 0 0-1.752 1.752v.5Z"
      clipRule="evenodd"
    />
    <circle cx={14} cy={10} r={1} fill="currentColor" />
    <circle cx={17} cy={10} r={1} fill="currentColor" />
  </IconBase>
);

export default HelpIcon;
